import React, { Component } from 'react'

require('./welcome.scss')

class Welcome extends Component {
  render() {
    return (
      <div className="welcome-screen">
        <h1>Welcome to #TheCabin</h1>
        <div>
          We are a community of people from all over the world originally formed in 1995 and are excited to have you join us!
          <br />
          <br />Feel free to visit our web site for more information at{' '}
          <a href="https://www.the-cabin.com" target="_new">
            www.the-cabin.com
          </a>.
        </div>
      </div>
    )
  }
}

export default Welcome



// WEBPACK FOOTER //
// ./src/views/welcome/Welcome.jsx